/**
 * The supplied screen exports (public/screens/*.webp). Originally shipped as SVGs wrapping a
 * <foreignObject> of real HTML — Safari doesn't scale foreignObject content to an <img>'s
 * rendered size the way Chrome does (a long-standing WebKit limitation), so a screen would
 * render near its native pixel width regardless of the frame it was placed in and spill past it
 * (GH-899). Rasterizing to WebP at 2x sidesteps that entirely: ordinary image scaling has no
 * such bug, and ordinary image scaling is all a static phone/browser mockup ever needed.
 * Illustrative event data throughout; every place these render is captioned "illustrative" or
 * "example" so nothing here reads as a real customer's numbers (CLAUDE.md: never invent metrics
 * or pass off illustrative data as real).
 */
export type ScreenName = "giving" | "receipt" | "overview" | "live" | "gifts";

interface ProductScreenProps {
  screen: ScreenName;
  eager?: boolean;
}

export function ProductScreen({ screen, eager = false }: ProductScreenProps) {
  return (
    <img
      className="product-screen"
      src={`/screens/${screen}.webp`}
      alt={`GiveHere ${screen} screen, illustrative event data`}
      loading={eager ? "eager" : "lazy"}
      draggable={false}
    />
  );
}

interface PhoneProps {
  screen: ScreenName;
  className?: string;
}

export function Phone({ screen, className = "" }: PhoneProps) {
  return (
    <div className={`phone ${className}`} aria-hidden="true">
      <div className="phone__inner">
        <ProductScreen screen={screen} eager />
        <div className="phone__island" />
      </div>
    </div>
  );
}
